import { SimpleAccordion } from 'components/simpleAccordion';
import { SkeletonIppicaQuoteFinaliArea } from 'components/skeletonIppicaQuoteFinaliArea/SkeletonIppicaQuoteFinaliArea';
import { selectIppicaQuoteFinali, selectIsLoadingQuoteCombinate } from 'features/ippica/selectors';
import { useTypedSelector } from 'lib/centralStore';
import { IppicaEmpty } from '../../ippicaEmpty';
import { DynamicIppicaQuoteFinaliBox } from '../ippicaQuoteFinaliBox/IppicaQuoteFinaliBox';
import styles from './IppicaQuoteAccordion.module.scss';

export type IppicaQuoteAccordionProps = {
  title?: string;
  // quoteFinali: IppicaQuoteFinaliBoxProps[];
  index: number;
  hasMarginRight?: boolean;
  hasMarginBottom?: boolean;
  codiceTipoScommessa: number;
  activeIndex?: number | null;
  onToggle?: (index: number, codiceTipoScommessa: number) => void;
};

export const IppicaQuoteAccordion = ({
  title,
  index,
  hasMarginRight,
  hasMarginBottom,
  codiceTipoScommessa,
  activeIndex,
  onToggle,
}: IppicaQuoteAccordionProps) => {
  const ippicaQuoteFinali = useTypedSelector(selectIppicaQuoteFinali);
  const isLoadingIppicaQuoteFinali = useTypedSelector(selectIsLoadingQuoteCombinate);

  return (
    <SimpleAccordion
      className={`${styles.container} ${hasMarginRight ? styles.withMarginRight : ''} ${
        hasMarginBottom ? styles.withMarginBottom : ''
      }`}
      title={title ?? ''}
      triggerWrapperClassName={styles.triggerWrapper}
      contentWrapperClassName={styles.contentWrapper}
      isOpen={index === activeIndex}
      onToggle={() => onToggle && onToggle(index, codiceTipoScommessa)}
    >
      <div className={styles.childrenWrapper}>
        {isLoadingIppicaQuoteFinali && <SkeletonIppicaQuoteFinaliArea />}
        {index === activeIndex && !ippicaQuoteFinali?.length && (
          <IppicaEmpty className={styles.emptyColumn}>
            <span>Non ci sono dati</span>
          </IppicaEmpty>
        )}
        {index === activeIndex &&
          !isLoadingIppicaQuoteFinali &&
          !!ippicaQuoteFinali?.length &&
          ippicaQuoteFinali.map((quotaCombinata, index) => {
            const { combinazione, quota } = quotaCombinata ?? { combinazione: '', quota: '' };
            return (
              <DynamicIppicaQuoteFinaliBox
                key={combinazione + '_' + index}
                title={combinazione}
                esitoList={[{ quota: String(quota) }]}
                hasMarginBottom
                containerClassName={styles.box}
              />
            );
          })}
      </div>
    </SimpleAccordion>
  );
};
